
import {
  useEffect
  , useCallback
}
  from 'react';

import {
  useNavigate
  , useLocation
}
  from 'react-router-dom';

import { useConfig } from 'app/context/config';
import { useQuery } from 'app/context/query';
import { useRouteServers } from 'app/context/route-servers';

import PageHeader from 'app/components/page/Header';
import Content from 'app/components/content/Content';
import SearchGlobalInput from 'app/components/search/SearchGlobalInput';
import SummaryCards, { SummaryCard }
  from 'app/components/summary/SummaryCards';



const StartGlobalSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { prefix_lookup_enabled } = useConfig();
  const [{ q }] = useQuery({ q: "" });

  const openSearch = useCallback((qry) => {
    if (!prefix_lookup_enabled || qry === "") {
      return;
    }
    navigate({ ...location, pathname: "/search" }, { replace: true });
  }, [prefix_lookup_enabled, navigate, location]);

  // Make sure location is search when we are running a query
  useEffect(() => {
    openSearch(q);
  }, [q, openSearch]);

  if (!prefix_lookup_enabled) {
    return null;
  }

  return (
    <div className="lookup-container">
      <div className="col-md-8">
        <SearchGlobalInput />
      </div>
    </div>
  );
}


const StartPage = () => {
  const routeServers = useRouteServers();
  const { prefix_lookup_enabled } = useConfig();
  const groups = new Set(routeServers.map((routeServer) => routeServer.group));

  return (
    <div className="welcome-page">
      <PageHeader
        title="Visão geral"
        subtitle="Status e ferramentas do Looking Glass da GB Online." />

      <div className="jumbotron">
        <h1><Content id="welcome.title">PTT GB Online</Content></h1>
        <p><Content id="welcome.tagline">Looking Glass</Content></p>
      </div>

      <SummaryCards ariaLabel="Resumo do Looking Glass">
        <SummaryCard
          label="Route servers"
          value={routeServers.length}
          helper="disponíveis para consulta" />
        <SummaryCard
          label="Grupos"
          value={groups.size}
          helper="grupos de route servers" />
        <SummaryCard
          label="Prefix lookup"
          value={prefix_lookup_enabled ? "Disponível" : "Indisponível"}
          helper="consulta global"
          tone={prefix_lookup_enabled ? "success" : "warning"} />
      </SummaryCards>

      <StartGlobalSearch />
    </div>
  );
}

export default StartPage;
